import { render, staticRenderFns } from "./TouchRange.vue?vue&type=template&id=36bebb0d&"
import script from "./TouchRange.vue?vue&type=script&lang=js&"
export * from "./TouchRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports